import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type DownloadProps = React.HTMLAttributes<HTMLDivElement> & {};

export const Download: React.FC<DownloadProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/download.svg"} alt="" />
    </div>
  );
};